import Vue from 'vue'
/* ============
 * Plugins
 * ============ */
import './plugins/vuex'
import './plugins/axios'
import {router} from './plugins/vue-router'
import './plugins/vuex-router-sync'
import {MetaInfo} from 'vue-meta'
import store from './store'
import App from '@/App.vue'
// spectre
import './assets/sass/spectre.sass'
// main sass
import '@/assets/sass/main.sass'
// autocomplete
import '../node_modules/v-autocomplete/dist/v-autocomplete.css'
import Autocomplete from 'v-autocomplete'
// facebook sign in
import * as FBSignInButton from 'vue-facebook-signin-button'
// google sign in
import * as GSignInButton from 'vue-google-signin-button'
/* ============
 * App files
 * ============ */

declare module 'vue/types/vue' {
    // Global properties can be declared
    // on the `VueConstructor` interface
    interface VueConstructor {
        router: any,
        axios: any
    }
}

declare module 'vue/types/options' {
    interface ComponentOptions<V extends Vue> {
        metaInfo?: MetaInfo | (() => MetaInfo)
    }
}

Vue.use(Autocomplete)

Vue.use(FBSignInButton)

Vue.use(GSignInButton)
Vue.config.productionTip = false

// tslint:disable-next-line:no-unused-expression
new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
})
